<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="undefined"
    ref="purchase-planning"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :gcPopupDataGridConfig="gcPopupDataGridConfig"
    :serverError="serverError"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import CheckBox from "devextreme/ui/check_box";
import {
  PurchasePlanningTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/purchasing/purchase-planning-tabs";
import { PurchasePlanningService } from "../../_services/api/purchasing/purchase-planning.service";
import { mapGetters } from "vuex";
import { getFactorByCode } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      reload: false,
      validationSummary: [],
      dataModel: {
        // PurchaseDate: new Date(),
        ShowAll: false,
      },
      productPlanningItems: [],
      reviewBySupplierItems: [],
      gcPopupDataGridItems: [],
      gcPopupVisible: false,
      defaultBranchCode: undefined,
      SODistributionParentLine: {
        ProductDescription1: undefined,
        ProductCode: undefined,
      },
      payloadModel: {
        Commit: "Y",
        SupplierCode: undefined,
        SupplierName: undefined,
        ManufacturerCode: "",
        ItemCode: undefined,
        ItemDescn: undefined,
        ROP: undefined,
        ROQ: undefined,
        OnhandQty: undefined,
        CommittedQty: undefined,
        AvailableQty: undefined,
        OnPurchaseQty: undefined,
        ActualShortfallQty: undefined,
        UserOrderQty: undefined,
        UserRequiredByDate: undefined,
        ListPrice: undefined,
        DiscPcnt: undefined,
        WeightKg: undefined,
        VolumeM3: undefined,
        PackSize: undefined,
        SixMonthAverage: undefined,
        Code: "",
        ExchangeRate: undefined,
        Username: undefined,
        OrderPriority: "S",
        ItemType: undefined,
        UM: undefined,
        OneMonthPrior: undefined,
        TwoMonthPrior: undefined,
        ThreeMonthPrior: undefined,
        FourMonthPrior: undefined,
        FiveMonthPrior: undefined,
        SixMonthPrior: undefined,
        CalcShortfallQty: undefined,
        SixMonthAverageHidden: undefined,
        UnitWeightKg: undefined,
        UnitVolumeM3: undefined,
        SupplierCurrency: undefined,
        SourceSalesOrder: undefined,
        SourceSalesOrderLine: undefined,
        SourceWorkOrder: undefined,
        SourceProcessCode: undefined,
        BranchCode: undefined,
        SalesOrder: undefined,
        RunId: undefined,
        NextStatus: "A",
        DirectDelivery: "Y",
      },
      disableSODModelSave: true,
      RunID: undefined,
      serverError: {},
      getGenerateEndpoint: "PurchasePlanningItem",
    };
  },

  async created() {
    // await this.$store.dispatch("screenFactors/getFactors", [18]);

    await this.$store.dispatch("screenFactors/getFactors", [65]);
    this.defaultBranchCode = getFactorByCode(65).Factorc;
    this.initialized();
  },
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    getDataModel() {
      return this.dataModel;
    },
    getProductPlanningItems() {
      return this.productPlanningItems;
    },
    getScreenJson() {
      var screenJson = {
        title: "Purchase Planning",
        endpoint: {
          primary: undefined,
          //   postProcess: this.supplierInvoicePostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint: undefined
              // filter:
              //   this.baseView.mode !== "create"
              //     ? ["SupplierInvoiceCode eq " + this.baseView.id]
              //     : ["PurchaseOrderCode eq " + this.baseView.id],
              serverPaging: false,
              allowGrouping: false,
              // postProcessCallback: this.PostProcess,
            },
            noDataMessage: {
              "product-planning": {
                addNew: {
                  class: "add-new",
                  title: "Plan Your Purchasing",
                  message:
                    "Get started by adding parameters and generating your requirements",
                },
              },
              review: {
                addNew: {
                  class: "add-new",
                  title: "Plan Your Purchasing",
                  message:
                    "Get started by adding parameters and generating your requirements",
                },
              },
            },
            options: {
              //   wordWrapEnabled: false,
              selectionMode: "none",
            },

            dynamicColumns: true,
            dataGridViews: [
              {
                label: "Product Planning",
                value: "product-planning",
                default: true,
                dataSource: {
                  localDataList: true,
                  items: this.getProductPlanningItems,
                  postProcessCallback: this.productPlanningPostProcess,
                  serverPaging: false,
                },
                columns: this.getProductPlanningColumns,
              },
              {
                label: "Review by Supplier",
                value: "review",
                default: false,
                dataSource: {
                  localDataList: true,
                  items: this.reviewBySupplierPostProcess(
                    this.reviewBySupplierItems
                  ),
                },
                columns: this.getReviewBySupplierColumns,
                // childColumns: this.getReviewBySupplierChildColumns,
              },
            ],
          },
          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: true,
            review: true,
          },
          columns: [],

          valueChangedEventListners: [
            {
              dataField: "OrderQty",
              listner: (e, lineData) => {
                lineData.data.OrderQty = e.value;
                lineData.data.CheckInclude = true;
                this.$refs["purchase-planning"].$refs[
                  "transactionGrid"
                ].gridRepaint();

                this.onOrderQTYChanged(e, lineData);

                this.checkBoxValueChange(
                  { value: true, event: true },
                  lineData
                );
              },
            },
          ],
        },
        // footerData: {
        //   footerItems: [],
        // },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerToolbar: {
            screenName: "Purchase Orders - Invoiced",
            pdf: this.baseView.mode == "review",
            audit: this.baseView.mode == "review",
            status: this.baseView.mode == "review",
            notes: false,
            save: this.baseView.mode != "review",
            saveCallback: this.savePurchasePlanning,
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 4,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      dataField: "BranchCode",
                      label: {
                        text: "Branch",
                      },
                      editorOptions: {
                        // allowUpdate: false,
                      },
                      required: true,
                      defaultValue: this.defaultBranchCode,
                    },
                    {
                      screenField: "Supplier",
                      dataField: "SupplierCode",
                      label: {
                        text: "Supplier",
                      },
                      editorOptions: {
                        showClearButton: true,
                        onValueChanged: (e) => {
                          this.onSupplierValueChanged(e);
                        },
                      },
                      // required: true,
                      // defaultValue: "10007",
                    },
                    {
                      dataField: "ShowAll",
                      label: {
                        text: "Show All Items",
                      },
                      cssClass: "myCss",
                      editorType: "dxCheckBox",
                      editorOptions: {
                        // onValueChanged: () => {
                        //   this.onChangeFXFreight();
                        // },
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "ProductCategory1",
                      label: {
                        text: "Prod Cat 1",
                      },
                      editorOptions: {
                        showClearButton: true,
                      },
                    },
                    {
                      screenField: "ProductCategory2",
                      label: {
                        text: "Prod Cat 2",
                      },
                      editorOptions: {
                        showClearButton: true,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "ProductCategory3",
                      label: {
                        text: "Prod Cat 3",
                      },
                      editorOptions: {
                        showClearButton: true,
                      },
                    },
                    {
                      screenField: "ProductCategory4",
                      label: {
                        text: "Prod Cat 4",
                      },
                      editorOptions: {
                        showClearButton: true,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "ProductType",
                      editorOptions: {
                        showClearButton: true,
                      },
                      //   label: {
                      //     text: "Prod Cat 2",
                      //   },
                    },

                    {
                      dataField: "Generate",
                      label: {
                        text: " ",
                      },
                      cssClass: "generate-btn",
                      editorType: "dxButton",
                      editorOptions: {
                        validationGroup: "gc-header-form",
                        onClick: async (e) => {
                          if (e) this.onGenerateClick(e);
                          else return;
                        },
                        text: "Generate",
                        type: "default",
                        rtlEnabled: true,
                        // useSubmitBehavior: true,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Purchase Planning",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          selectedIndex: GetIndexByTabName("Generate"),
          tabs: PurchasePlanningTabs,
        },
      };
    },
    getProductPlanningColumns() {
      return [
        {
          screenField: "CheckInclude",
          allowEditing: false,
          defaultValue: false,
          valueChangeCallBack: this.checkBoxValueChange,
          allowHiding: false,
          showInColumnChooser: false,
          fixed: true,
          fixedPosition: "left",
          label: "",
          width: 50,
          minWidth: 50,
          visible: this.baseView.mode == "create",
        },
        {
          screenField: "Supplier",
          allowHiding: false,
          gridDataField: "SupplierCode",
          allowGrouping: false,
          cellTemplate: "HyperLinkText",
          // cellTemplateRecord: undefined,
          // exportFields: undefined,
          //   dataField: "GoodsInCode",
          width: "auto",
          // width: 100,
          // minWidth: 100,
          // filterIndex: 0,
          activeHyperLink: (data) => {
            if (data.data.SupplierCode == "Multiple") return true;
            else return false;
          },
          customHyperLink: (data) => {
            this.getSupplierOrderDistribution(data);
          },
          sortOrder: "asc",
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          exportFields: [
            {
              dataField: "SupplierCode",
              label: "Supplier Code",
              showInColumnChooser: false,
            },
            {
              dataField: "SupplierName",
              label: "Supplier Name",
              showInColumnChooser: false,
            },
          ],
        },

        {
          screenField: "Product",
          allowHiding: false,
          gridDataField: "ItemDescn",
          width: "auto",
          // minWidth: "auto",
          filterIndex: 1,
          cellTemplateRecord: {
            image: {
              codeDataField: "ProductCode",
              descriptionDataField: "ProductDescription1",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField: "ProductDescription1",
              },
            ],
            secondary: [
              {
                dataField: "ProductCode",
              },
            ],
          },
          fixed: true,
          fixedPosition: "left",
        },
        {
          screenField: "SalesUM",
          dataField: "StockUM",
          width: 80,
          minWidth: 80,
        },
        {
          screenField: "Packsize",
          dataField: "PackSize",
          width: 120,
          minWidth: 120,
        },
        {
          screenField: "OnHand",
          dataField: "OnhandQty",
          width: 140,
          minWidth: 140,
        },
        {
          screenField: "Committed",
          dataField: "CommittedQty",
          hyperlink: {
            url: "report/product/grid/product-commitments",
            target: "_blank",
            params: ["Branch", "Product"],
          },
          width: 140,
          minWidth: 140,
        },
        {
          screenField: "Available",
          dataField: "AvailableQty",
          width: 140,
          minWidth: 140,
        },
        {
          screenField: "IncomingOrders",
          dataField: "IncomingPOQty",
          label: "Incoming",
          hyperlink: {
            url: "report/product/grid/incoming-orders",
            target: "_blank",
            params: ["Branch", "Product"],
          },
          width: 140,
          minWidth: 140,
        },
        {
          screenField: "Suggested",
          dataField: "SuggestedQty",
          width: 140,
          minWidth: 140,
        },
        {
          screenField: "Quantity",
          label: "Order Qty",
          dataField: "OrderQty",
          type: "EditableDecimal",
          format: "Decimal-16-4",
          showEditorAlways: true,
          allowSearch: false,
          allowFiltering: false,
          width: 140,
          minWidth: 140,
          minmax: { max: 99999999.0 },
        },
        {
          screenField: "3MonthsAverage",
          dataField: "ThreeMonthAverage",
          label: "3 Mth Avg",
          visible: false,
        },
        {
          screenField: "6MonthsAverage",
          dataField: "SixMonthAverage",
          label: "6 Mth Avg",
          visible: false,
        },
        {
          screenField: "FourWeekAverage",
        },
        {
          screenField: "ThirteenWeekAverage",
        },
        {
          screenField: "ROP",
          dataField: "ROP",
          width: 120,
          minWidth: 120,
        },
        {
          screenField: "ROQ",
          dataField: "ROQ",
          width: 120,
          minWidth: 120,
        },
        {
          screenField: "ProductCategory1",
          filterLabel: "Prod Cat 1",
          filterIndex: 2,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory2",
          filterLabel: "Prod Cat 2",
          filterIndex: 3,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory3",
          filterLabel: "Prod Cat 3",
          filterIndex: 4,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductCategory4",
          filterLabel: "Prod Cat 4",
          filterIndex: 5,
          showInColumnChooser: false,
          visible: false,
        },
        {
          screenField: "ProductType",
          filterLabel: "Prod Type",
          filterIndex: 6,
          showInColumnChooser: false,
          visible: false,
        },
      ];
    },
    getReviewBySupplierColumns() {
      var columns = [
        {
          label: "Supplier",
          // sortOrder: "asc",
          // sortIndex: 0,
          width: "auto",
          allowHiding: false,
          dataField: "SupplierDescription",
          cellTemplate: undefined,
          cellTemplateRecord: undefined,
          exportFields: undefined,
          groupIndex: 0,
        },
        {
          screenField: "Product",
          //   dataField: this.baseView.mode == "create" ? "LineType" : "ItemType",
          // label: "Type",
          minWidth: 100,
          filterIndex: 1,
        },
        {
          screenField: "SalesUM",
          dataField: "StockUM",
          width: 80,
          minWidth: 80,
        },
        {
          screenField: "Quantity",
          dataField: "OrderQty",
          label: "Order Qty",
        },
      ];
      // return columns;
      return columns;
    },
    getReviewBySupplierChildColumns() {
      var columns = [
        {
          screenField: "Product",
          //   dataField: this.baseView.mode == "create" ? "LineType" : "ItemType",
          // label: "Type",
          minWidth: 100,
          filterIndex: 1,
        },
        {
          screenField: "SalesUM",
          //   dataField: "SupplierUM",
          width: 80,
          minWidth: 80,
        },
        {
          screenField: "Quantity",
          label: "Order Qty",
        },
      ];
      // return columns;
      return columns;
    },
    gcPopupDataGridConfig() {
      return {
        // title: "Product Supplier Definition",
        titles: {
          primary:
            "Product Supplier Definition for " +
            this.SODistributionParentLine.ProductDescription1,
          secondary: this.SODistributionParentLine.ProductCode,
        },
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 400,
        popupWidth: "80%",
        save: {
          text: "Save",
          clickCallback: () => {
            this.gcPopupSaveCallBack();
          },
          disabled: this.disableSODModelSave,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              postProcessCallback: this.gcPopupDataGridItemsPostProcess,

              localDataList: true,
              items: this.gcPopupDataGridItems,
            },
            footerEnabled: false,
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
          },
          columns: [
            {
              screenField: "Supplier",
            },
            {
              label: "Order %",
              dataField: "PlanningPcnt",
              screenField: "Quantity",
              // dataField: "OrderQty",
              type: "EditableDecimal",
              format: "Decimal-16-4",
              showEditorAlways: true,
              allowSearch: false,
              allowFiltering: false,
              width: 110,
              minWidth: 110,
              minmax: { max: 999999.0 },
            },
            {
              label: "Order Qty",
              screenField: "Quantity",
              dataField: "OrderQty",
              format: "Decimal-16-4",
            },
            {
              label: "Price",
              dataField: "ListPrice",
            },
            {
              screenField: "FXLineTotal",
              label: "Total",
              dataField: "LineTotal",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "PlanningPcnt",
              listner: (e, lineData) => {
                if (!e.event) return;
                else this.onPlanningPcntChanged(e, lineData);
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    async onOrderQTYChanged(e, lineData) {
      if (lineData.data.CheckInclude) {
        var index = this.reviewDataSource.findIndex(
          (x) => x.ProductCode == lineData.data.ProductCode
        );

        if (lineData.data.SupplierCode == "Multiple") {
          if (lineData.data.SupplierOrderDistributionList) {
            lineData.data.SupplierOrderDistributionList.forEach(
              async (element) => {
                element.OrderQty =
                  lineData.data.OrderQty * (element.PlanningPcnt / 100);
                await this.addToReviewFromMultiple(element, lineData.data);
              }
            );
          }
        } else {
          if (e.value == 0) {
            if (index != -1) {
              this.removeFromReview(index);
            }
          } else {
            if (index != -1) {
              this.removeFromReview(index);
            }
            this.addToReview(lineData.data);
          }
        }
      }
    },
    removeAllFromReview() {
      this.$store.dispatch("dataContext/setReviewDataSource", []);
    },
    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    addToReviewFromMultiple(element, record) {
      if (element.SupplierDescription == "Multiple") return;
      var index = this.reviewDataSource.findIndex(
        (x) =>
          x.ProductCode == element.ProductCode &&
          x.SupplierCode == element.SupplierCode
      );

      if (element.OrderQty == 0) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        if (element.OrderQty > 0) {
          var data = { ...element };
          data.ProductDescription1 = record.ProductDescription1;
          // data.StockUM = element.SupplierUM;
          this.addToReview(data);
        }
      }
    },
    onSupplierValueChanged(e) {
      if (e.value) this.getGenerateEndpoint = "PurchasePlanningData";
      else this.getGenerateEndpoint = "PurchasePlanningItem";
    },
    async savePurchasePlanning(header, details) {
      var payload = {
        Code: "0000",
        Purchdat: [],
      };

      details = this.productPlanningItems;

      var items = details.filter((x) => x.CheckInclude == true);

      if (items.length == 0) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: `Purchase Planning has no detail. Please add one or more lines before attempting to save again.`,
        });
      } else {
        var zeroItems = [];
        this.setLoading = true;
        items.forEach((element) => {
          var data = {};
          if (element.OrderQty == 0) zeroItems.push(element);
          if (element.SupplierCode != "Multiple") {
            for (const key in this.payloadModel) {
              if (this.payloadModel[key]) data[key] = this.payloadModel[key];
              else {
                if (!data[key]) data[key] = element[key];
                data.UserOrderQty = element.OrderQty;
                data.UM = element.StockUM;
              }
            }
            payload.Purchdat.push(data);
          } else {
            element.SupplierOrderDistributionList.forEach((x) => {
              data = {};
              if (x.OrderQty == 0) return;
              for (const key in this.payloadModel) {
                if (this.payloadModel[key]) data[key] = this.payloadModel[key];
                else {
                  if (!data[key]) data[key] = element[key];
                }
              }
              data.UserOrderQty = x.OrderQty;
              data.UM = x.SupplierUM;
              data.SupplierCode = x.SupplierCode;
              data.SupplierName = x.SupplierDescription;
              payload.Purchdat.push(data);
            });
          }
          // console.log("XXXX 1", data);
        });
        // console.log("XXXX 1", payload);
        // console.log("XXXX 2", JSON.stringify(payload));

        if (payload.Purchdat.length == 0) {
          this.setLoading = false;
          this.validationSummary = [];
          this.validationSummary.push({
            message: `Purchase Planning has no detail. Please add Supplier line details before attempting to save again.`,
          });
          return;
        }

        if (zeroItems.length > 0) {
          this.setLoading = false;
          this.validationSummary = [];
          var errors = [];
          errors.push({
            message:
              "The following products have been selected but do not have quantities specified",
          });

          zeroItems.forEach((zero, index) => {
            errors.push({
              message: `${index + 1}. ${zero.ProductDescription1}`,
            });
          });

          this.validationSummary = errors;

          return;
        }

        await PurchasePlanningService.savePurchasePlanning(payload)
          .then((res) => {
            if (res) this.setLoading = false;
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/purchase-planning-orders`,
              query: {
                run_id: encodeURI(this.RunId),
              },
            });
          })
          .catch((err) => {
            this.setLoading = false;
            this.serverError = {
              err: err,
              msg: "Purchase Planning save failed",
              time: new Date().getTime(),
            };
          });
      }
    },
    onPlanningPcntChanged(e, lineData) {
      this.disableSODModelSave = false;
      var prcntTotal = 0;
      this.gcPopupDataGridItems.forEach((element) => {
        prcntTotal = prcntTotal + element.PlanningPcnt;
      });

      if (prcntTotal - e.previousValue + e.value > 100) {
        lineData.data.PlanningPcnt = e.previousValue;

        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.validationSummary = [];
        this.validationSummary.push({
          message:
            "The sum of the Order % across all suppliers attached to the Product must not be > 100.00%",
        });
      } else {
        lineData.data.PlanningPcnt = e.value;
        lineData.data.OrderQty =
          this.SODistributionParentLine.OrderQty * (e.value / 100);
        lineData.data.LineTotal =
          lineData.data.OrderQty * lineData.data.ListPrice;
      }
    },
    gcPopupDataGridItemsPostProcess(items) {
      items.forEach((element) => {
        element.OrderQty =
          this.SODistributionParentLine.OrderQty * (element.PlanningPcnt / 100);
        element.LineTotal = element.OrderQty * element.ListPrice;
      });

      return items;
    },
    async checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) {
        setTimeout(() => {
          this.updateHeaderCheckBox(this.productPlanningItems);
        }, 500);
        return;
      }

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          this.$store.dispatch("dataContext/setReviewDataSource", []);
          this.productPlanningItems.forEach(async (item) => {
            if (fieldData.value) {
              if (item.OrderQty == 0) item.OrderQty = item.SuggestedQty;
              item.CheckInclude = true;
              if (
                !item.SupplierOrderDistributionList &&
                item.SupplierCode == "Multiple"
              ) {
                this.setLoading = true;
                await PurchasePlanningService.getCustomData({
                  // url: "ProductPurchase",
                  // filter: `ProductCode eq '${item.ItemCode}'`,
                  // expand: "Supplier",
                  // orderby: "Rank",

                  url: "PurchasePlanningData",
                  filter: `ItemCode eq '${item.ItemCode}' and RunId eq ${this.RunId}`,
                  orderby: "SupplierRank",
                })
                  .then(async (result) => {
                    result.data.value.forEach(async (element) => {
                      // element.SupplierDescription = element.Supplier.Name;
                      element.SupplierDescription = element.SupplierName;
                      element.OrderQty =
                        item.OrderQty * (element.PlanningPcnt / 100);

                      await this.addToReviewFromMultiple(element, item);
                    });

                    item.SupplierOrderDistributionList = result.data.value;
                    this.setLoading = false;
                  })
                  .catch((err) => {
                    if (err) this.setLoading = false;
                  });
              } else if (item.OrderQty > 0 && item.SupplierCode != "Multiple") {
                this.addToReview(item);
              }
            } else {
              item.OrderQty = 0;
              item.CheckInclude = false;
              this.$store.dispatch("dataContext/setReviewDataSource", []);
            }
          });
          // this.productPlanningItems = gridItems;
          this.$refs["purchase-planning"].$refs[
            "transactionGrid"
          ].updateOptions("dataSource", this.productPlanningItems);
        }
      } else {
        recordData.data.CheckInclude = fieldData.value;
        if (fieldData.value) {
          if (fieldData.event && fieldData.component)
            recordData.data.OrderQty = recordData.data.SuggestedQty;
          if (
            recordData.data.OrderQty > 0 &&
            recordData.data.SupplierCode != "Multiple"
          ) {
            var indexi = this.reviewDataSource.findIndex(
              (x) => x.ProductCode == recordData.data.ProductCode
            );
            if (indexi != -1) {
              this.removeFromReview(indexi);
            }
            this.addToReview(recordData.data);
          }
        } else {
          recordData.data.OrderQty = 0;
          var length = this.reviewDataSource.length;

          for (let x = 0; x < length; x++) {
            var index = this.reviewDataSource.findIndex(
              (x) => x.ProductCode == recordData.data.ProductCode
            );
            if (index != -1) {
              this.removeFromReview(index);
            }
          }
        }

        if (
          fieldData.value &&
          !recordData.data.SupplierOrderDistributionList &&
          recordData.data.SupplierCode == "Multiple"
        ) {
          this.setLoading = true;
          await PurchasePlanningService.getCustomData({
            // url: "ProductPurchase",
            // filter: `ProductCode eq '${recordData.data.ItemCode}'`,
            // expand: "Supplier",
            // orderby: "Rank",

            url: "PurchasePlanningData",
            filter: `ItemCode eq '${recordData.data.ItemCode}' and RunId eq ${this.RunId}`,
            orderby: "SupplierRank",
          })
            .then(async (result) => {
              result.data.value.forEach(async (element) => {
                // element.SupplierDescription = element.Supplier.Name;
                element.SupplierDescription = element.SupplierName;
                element.OrderQty =
                  recordData.data.OrderQty * (element.PlanningPcnt / 100);

                await this.addToReviewFromMultiple(element, recordData.data);
              });

              recordData.data.SupplierOrderDistributionList = result.data.value;
              this.setLoading = false;
            })
            .catch((err) => {
              if (err) this.setLoading = false;
            });
        } else if (
          fieldData.value &&
          recordData.data.SupplierOrderDistributionList &&
          recordData.data.SupplierCode == "Multiple"
        ) {
          recordData.data.SupplierOrderDistributionList.forEach(
            async (element) => {
              await this.addToReviewFromMultiple(element, recordData.data);
            }
          );
        }
        this.$refs["purchase-planning"].$refs["transactionGrid"].gridRepaint();
      }

      this.updateHeaderCheckBox(this.productPlanningItems);
      // this.$refs["purchase-planning"].$refs["transactionGrid"].gridRepaint();
    },

    updateHeaderCheckBox(gridItems) {
      var refHeadInstance =
        this.$refs["purchase-planning"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }
      }, 10);
    },
    async getSupplierOrderDistribution(data) {
      this.SODistributionParentLine = data.data;
      this.setLoading = true;
      if (!data.data.SupplierOrderDistributionList)
        await PurchasePlanningService.getCustomData({
          url: "PurchasePlanningData",
          filter: `ItemCode eq '${data.data.ItemCode}' and RunId eq ${this.RunId}`,
          orderby: "SupplierRank",
        })
          .then((result) => {
            this.gcPopupDataGridItems = result.data.value;
            this.gcPopupDataGridItems.forEach((element) => {
              // element.SupplierDescription = element.Supplier.Name;
              element.SupplierDescription = element.SupplierName;
            });

            data.data.SupplierOrderDistributionList = this.gcPopupDataGridItems;

            setTimeout(() => {
              this.setLoading = false;
              this.gcPopupVisible = true;
            }, 150);
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      else {
        this.gcPopupDataGridItems = data.data.SupplierOrderDistributionList;
        this.setLoading = false;
        this.gcPopupVisible = true;
      }
    },
    gcPopupCallBack() {
      this.gcPopupVisible = false;
      this.disableSODModelSave = true;
    },
    gcPopupSaveCallBack() {
      var total = 0;
      this.SODistributionParentLine.SupplierOrderDistributionList.forEach(
        (item) => {
          total = total + item.PlanningPcnt;
        }
      );

      if (total < 100) {
        this.validationSummary = [];
        this.validationSummary.push({
          message:
            "The sum of the Order % across all suppliers attached to the Product must be at 100.00%",
        });
        return;
      } else {
        this.gcPopupCallBack();
        this.SODistributionParentLine.SupplierOrderDistributionList.forEach(
          async (element) => {
            await this.addToReviewFromMultiple(
              element,
              this.SODistributionParentLine
            );
          }
        );
      }
    },
    productPlanningPostProcess(items) {
      items.forEach((element) => {
        element.SupplierDescription = element.SupplierName;
        element.ProductCode = element.ItemCode;
        element.ProductDescription1 = element.ItemDescn
          ? element.ItemDescn
          : " ";
        if (element.SupplierCode == "Multiple") {
          element.SupplierDescription = "Multiple";
        }
        if (!element.OrderQty) element.OrderQty = 0; // element.SuggestedQty;
        if (!element.CheckInclude) element.CheckInclude = false;
      });
      if (items.length > 0) this.updateHeaderCheckBox(items);
      return items;
    },
    reviewBySupplierPostProcess(items) {
      var data = [];
      items.forEach((element) => {
        element.SupplierDescription = element.SupplierName;
        element.ProductCode = element.ItemCode;
        element.ProductDescription1 = element.ItemDescn
          ? element.ItemDescn
          : " ";
        if (element.SupplierCode && element.SupplierName) data.push(element);
      });
      // return items;
      return data;
    },
    async onGenerateClick(e) {
      if (this.productPlanningItems.length > 0) {
        let confirmGenerateClick = await this.$confirm(
          "This will result in losing your unsaved purchase plan. Are you sure you want to regenerate the data?",
          "Unsaved Changes"
        );

        if (!confirmGenerateClick) return;
      }
      this.removeAllFromReview();
      const result = await e.validationGroup.validate();

      if (!result.isValid) {
        this.$refs["purchase-planning"].showValidationSummary(
          result.brokenRules
        );
        return;
      } else {
        this.setLoading = true;
        var filter = "";
        var data = this.$refs["purchase-planning"].getTransactionData();
        if (!data.ShowAll) filter = "SuggestedQty gt 0";

        for (const key in data) {
          if (key != "ShowAll" && data[key]) {
            if (filter) filter = filter + " and ";
            filter = filter + `${key} eq '${data[key]}'`;
          }
        }

        await PurchasePlanningService.getGenerateData()
          .then(async (res) => {
            this.RunId = res.data.RunId;
            await PurchasePlanningService.getCustomData({
              url: this.getGenerateEndpoint,
              filter: filter + ` and RunId eq ${res.data.RunId}`,
            })
              .then(async (result) => {
                this.productPlanningItems = result.data.value;

                this.setLoading = false;
              })
              .catch((err) => {
                if (err) this.setLoading = false;
              });
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
    async initialized() {
      this.setLoading = true;
      this.loaded = true;
      this.setLoading = false;
    },
  },
  watch: {
    gridExpand() {
      setTimeout(() => {
        this.updateHeaderCheckBox(this.productPlanningItems);
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.generate-btn {
  .dx-field-item-content {
    text-align: right;
  }
}
</style>
